import { render } from "./AddTutarialCates.vue?vue&type=template&id=71a7349b&scoped=true"
import script from "./AddTutarialCates.vue?vue&type=script&lang=js"
export * from "./AddTutarialCates.vue?vue&type=script&lang=js"

import "./AddTutarialCates.vue?vue&type=style&index=0&id=71a7349b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71a7349b"]])

export default __exports__